import { T } from "../lib/fc3i18n";
import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { LanguageMenu } from "./fc3/LanguageUI";

// FemCare 3.0 header. Topic hubs that do not exist yet point to the
// closest existing page; swap the `to` values as each hub ships.
const links = [{
  to: "/features/cycle",
  label: "Period Health"
}, {
  to: "/blog/fertile-window-101-conception",
  label: "Fertility"
}, {
  to: "/features/pregnancy",
  label: "Pregnancy"
}, {
  to: "/features/daughter-care",
  label: "Daughter Care"
}, {
  to: "/fitness",
  label: "Fitness"
}, {
  href: "https://tools.femcare.life/period-calculator/",
  label: "Free Tools"
}, {
  to: "/blog",
  label: "Learn"
}, {
  to: "/pricing",
  label: "Premium"
}];
const linkCls = ({
  isActive
}) => `text-[15px] font-medium transition-colors py-3 ${isActive ? "text-[#E0306F]" : "text-[#1E1A2B] hover:text-[#E0306F]"}`;
export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const loc = useLocation();
  const dark = false;
  useEffect(() => {
    setOpen(false);
  }, [loc.pathname]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,box-shadow] duration-300 ${dark ? "bg-transparent border-b border-white/10" : scrolled ? "bg-[#FBF7F3]/95 backdrop-blur shadow-[0_1px_0_#F1E6EA,0_8px_24px_-16px_rgba(71,35,68,0.25)]" : "bg-[#FBF7F3] border-b border-[#F1E6EA]"}`} data-testid="site-header">
      <nav aria-label={T("Main")} className="max-w-[1240px] mx-auto px-5 lg:px-8 h-[74px] flex items-center justify-between gap-6">
        <Link to="/" className="flex items-center gap-3 shrink-0" data-testid="logo-link" aria-label={T("FemCare home")}>
          <img src="/femcare-logo-v2.png" alt="" className="h-11 w-11 rounded-full object-cover" />
          <span className={`text-[24px] transition-colors ${dark ? "text-white" : "text-[#2B2140]"}`} style={{
          fontFamily: "var(--fc-serif)",
          fontWeight: 500
        }}>{T("FemCare")}</span>
        </Link>

        <ul className="hidden xl:flex items-center gap-7">
          {links.map(l => <li key={l.label}>
              {l.href ? <a href={l.href} className={`text-[15px] font-medium transition-colors py-3 ${dark ? "text-white/85 hover:text-white" : "text-[#1E1A2B] hover:text-[#E0306F]"}`}>{T(l.label)}</a> : <NavLink to={l.to} className={dark ? "text-[15px] font-medium py-3 text-white/85 hover:text-white transition-colors" : linkCls} data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>{T(l.label)}</NavLink>}
            </li>)}
        </ul>

        <div className="hidden xl:flex items-center gap-4 shrink-0">
          <LanguageMenu />
          <a href="/app/login" className={`text-[15px] font-semibold px-2 py-3 ${dark ? "text-white hover:text-[#F4B69C]" : "text-[#2B2140] hover:text-[#E0306F]"}`} data-testid="header-login">{T("Log in")}</a>
          <a href="/app/signup" className={`inline-flex items-center min-h-[44px] rounded-full px-5 text-[15px] font-bold transition-colors ${dark ? "fc-btn-gold" : "text-white bg-[#E0306F] hover:bg-[#2B2140]"}`} data-testid="header-cta-pricing">{T("Get started free")}</a>
        </div>

        <div className="xl:hidden flex items-center gap-1"><LanguageMenu compact />
        <button type="button" className={`xl:hidden inline-flex items-center justify-center w-11 h-11 rounded-full ${dark ? "text-white hover:bg-white/10" : "text-[#2B2140] hover:bg-[#FFE9EF]"}`} onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle" aria-label={open ? T("Close menu") : T("Open menu")} aria-expanded={open}>
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button></div>
      </nav>

      {open && <div className="xl:hidden border-t border-[#F1E6EA] bg-[#FFF8F9]">
          <ul className="px-5 py-4 flex flex-col">
            {links.map(l => <li key={l.label}>
                {l.href ? <a href={l.href} className="block py-3 text-[17px] font-medium text-[#1E1A2B]">{T(l.label)}</a> : <NavLink to={l.to} className="block py-3 text-[17px] font-medium text-[#1E1A2B]">{T(l.label)}</NavLink>}
              </li>)}
            <li className="pt-3 flex flex-wrap gap-3">
              <a href="/app/signup" className="inline-flex items-center min-h-[48px] rounded-full px-6 font-semibold text-white bg-[#E0306F]">{T("Get started free")}</a>
              <a href="/app/login" className="inline-flex items-center min-h-[48px] rounded-full px-6 font-semibold text-[#2B2140] border border-[#2B2140]">{T("Log in")}</a>
            </li>
          </ul>
        </div>}
    </header>;
}